import { APIClient } from "../helpers/api_helper";
import { ApiResponse } from "../types/api";

const api = new APIClient();

export type ImageMarketingConsentStatus =
  | "active"
  | "expired"
  | "revoked"
  | "absent";

export interface ImageMarketingConsentTerm {
  id: number;
  title: string;
  purpose: string;
  specialty: string;
  body_text: string;
  version: number;
  is_active: boolean;
}

export interface ImageMarketingConsentSummary {
  id: number;
  status: ImageMarketingConsentStatus;
  consent_term_id: number | null;
  consent_term_version: number | null;
  signed_at: string | null;
  expires_at: string | null;
  revoked_at: string | null;
  has_signature_image: boolean;
}

export interface ImageMarketingConsentState {
  status: ImageMarketingConsentStatus;
  can_use_in_marketing: boolean;
  consent_term_outdated?: boolean;
  expires_soon?: boolean;
  expires_in_days?: number | null;
  consent: ImageMarketingConsentSummary | null;
  active_term: ImageMarketingConsentTerm | null;
}

export interface AcceptImageMarketingConsentPayload {
  accepted: boolean;
  consent_term_id?: number | null;
  consent_text_snapshot?: string | null;
  signature_image_base64?: string | null;
  expires_in_days?: number | null;
}

export const getImageMarketingConsent = (
  clientId: number
): Promise<ApiResponse<ImageMarketingConsentState>> =>
  api.get<ApiResponse<ImageMarketingConsentState>>(
    `/clients/${clientId}/image-marketing-consent`
  );

export const acceptImageMarketingConsent = (
  clientId: number,
  payload: AcceptImageMarketingConsentPayload
): Promise<ApiResponse<ImageMarketingConsentState>> =>
  api.create<ApiResponse<ImageMarketingConsentState>>(
    `/clients/${clientId}/image-marketing-consent`,
    payload
  );

export const revokeImageMarketingConsent = (
  clientId: number
): Promise<ApiResponse<ImageMarketingConsentState & { cleared_attachments?: number }>> =>
  api.create<ApiResponse<ImageMarketingConsentState & { cleared_attachments?: number }>>(
    `/clients/${clientId}/image-marketing-consent/revoke`,
    {}
  );
